<script lang="ts">
  import { setContext } from "svelte";
  import { writable } from "svelte/store";
  import type { Metadata } from "../../helpers/metadata";

  export let id = 0;
  const metadataStore = writable<Metadata | undefined>(undefined);
  const idStore = writable<number>(id);
  // const baseURI = "https://ipfs.io/ipfs/QmeSjSinHpPnmXmspMjwiXyN6zS4E9zccariGR3jxcaWtq/";
  const baseURI =
    "/img/nft/";

  setContext("metadata", metadataStore);
  setContext("id", idStore);

  $: getMetadata(id);

  const getMetadata = async (id: number) => {
    const res = await fetch(`${baseURI}/${id}`);
    const metadata = await res.json();
    metadataStore.set(metadata);
  };
</script>

{#if $metadataStore}
  <slot />
{/if}
